module.exports = __webpack_public_path__ + "static/media/420SunsetAveNW_2018-06-11_153.9b2d1726.jpg";